<template>
  <div>
    <div class="form-row form-row-wide">
      <div class="form-field">
        <hidden-select-button button-text="Указать участок" ref="plotButton">
          <select-area @select="onPlotSelect"></select-area>
        </hidden-select-button>
      </div>
      <div class="form-field">
        {{ plot_data.name }}
      </div>
      <div class="form-field">
        <label for="agreement-select">
          Тип соглашения:
        </label>
        <select
          id="agreement-select"
          v-model="newOwner.AGREEMENT_TYPE"
          v-on:change="getPenalty"
        >
          <option
            v-for="(type, key) in agreementsType"
            :value="type.ID"
            :key="key"
          >
            {{ type.NAME }}
          </option>
        </select>
      </div>
      <template v-if="newOwner.AGREEMENT_TYPE">
        <div class="form-field">
          <label for="type-penalty-percent-input">
            % пени в день:
          </label>
          <input
            type="text"
            id="type-penalty-percent-input"
            v-model="penalty.PERCENT"
          />
        </div>
        <div class="form-field">
          <label for="type-penalty-max-input">
            Лимит пени:
          </label>
          <input
            type="text"
            id="type-penalty-max-input"
            v-model="penalty.MAX"
          />
        </div>
        <div class="form-field">
          <label for="type-penalty-descr-input">
            Описание пени:
          </label>
          <input
            type="text"
            id="type-penalty-descr-input"
            v-model="penalty.DESCR"
          />
        </div>
      </template>
      <div class="form-field">
        <label for="owner-phone">
          Телефон:
        </label>
        <input id="owner-phone" v-model.lazy="phone" />
      </div>
      <div class="form-field">
        <label>
          ФИО:
        </label>
        <VueSuggestions
          :model.sync="newOwner.FIO"
          class="form-control"
          :options="suggestionOptions"
        >
        </VueSuggestions>
      </div>
      <div class="form-block">
        <div class="form-block-title">Паспортные данные</div>
        <div class="form-field">
          <label for="owner-passport">
            Серия номер:
          </label>
          <input v-model="newOwner.PASSPORT_NUMBER" id="owner-passport" />
        </div>
        <div class="form-field">
          <label for="owner-address">
            Адрес регистрации:
          </label>
          <VueSuggestions
            id="owner-address"
            :model.sync="newOwner.ADDRESS"
            class="form-control"
            :options="suggestionAddressOptions"
          >
          </VueSuggestions>
        </div>
      </div>
      <div class="form-field">
        <label for="owner-balance">
          Баланс договора:
        </label>
        <input v-model="newOwner.BALANCE" id="owner-balance" />
      </div>
      <div class="form-field">
        <label for="send-sms">
          Отправить СМС:
        </label>
        <input v-model="newOwner.send_sms" id="send-sms" type="checkbox" />
      </div>
      <div class="form-field">
        <button @click="sendOwnersData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";
import selectArea from "components/backoffice/owner/SelectArea";
import VueSuggestions from "vue-suggestions";

export default {
  name: "addOwners",
  components: {
    selectArea,
    VueSuggestions
  },

  data() {
    return {
      url: config.backend_url,
      info: null,
      newOwner: {
        USER: null,
        PLOT_ID: null,
        PHONE: null,
        ADDRESS: null,
        AGREEMENT_TYPE: null,
        PASSPORT_NUMBER: null,
        BALANCE: null,
        FIO: null,
        send_sms: false,
        sms_text: "Зайдите на http://lk.lokeo.ru"
      },
      penalty: {},
      services: [],
      villages: [],
      plots: [],
      users: [],
      agreementsType: [],
      plot_data: {},
      phone: "",
      passportNumber: "",
      showPenalty: false,
      suggestionOptions: {
        token: "6ee7f7a23d15556837b56d9ab065ad8e27f7eedb",
        type: "NAME",
        scrollOnFocus: false,
        triggerSelectOnBlur: false,
        triggerSelectOnEnter: false,
        addon: "none"
      },
      suggestionAddressOptions: {
        token: "6ee7f7a23d15556837b56d9ab065ad8e27f7eedb",
        type: "ADDRESS",
        scrollOnFocus: false,
        triggerSelectOnBlur: false,
        triggerSelectOnEnter: false,
        addon: "none"
      }
    };
  },
  computed: {},
  methods: {
    sendOwnersData: function() {
      let self = this;
      this.newOwner.PHONE = this.phone;
      this.newOwner.PLOT = this.plot_data.id;
      this.newOwner.VILLAGE = this.plot_data.village_id;
      this.newOwner.PENALTY = this.penalty;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "owners/add/",
          data: this.newOwner,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data.agreements) {
            self.info = "Собственник успешно добавлен";
            self.$emit("owner-add");
          }
        });
    },
    getPlots: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "plots/get/",
          filter: { VILLAGE: self.newOwner.VILLAGE },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.plots = !data.error ? data : [];
        });
    },
    getUsers: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "users/get/",
          filter: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.users = !data.error ? data : [];
        });
    },
    getAgreementsType: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "agreementTypeList/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.agreementsType = data;
          }
        });
    },
    getPenalty: function() {
      let self = this;
      let agreementType = self.agreementsType[self.newOwner.AGREEMENT_TYPE];
      if (agreementType.PENALTY) {
        this.$store
          .dispatch("query/sendRequest", {
            url: self.url + "penalties/get-by-id/" + agreementType.PENALTY,
            method: "POST"
          })
          .then(function(response) {
            let data = response.data;
            if (!data.error) {
              self.penalty = data;
            }
          });
      } else {
        self.penalty = {};
      }
    },
    onPlotSelect: function(item) {
      this.$refs.plotButton.toggleShow();
      this.plot_data = item.data;
      this.plot_data.village_id = item.village_id;
    }
  },
  watch: {
    phone: function() {
      let self = this;
      let data = {
        url: self.url + "users/get/",
        filter: { PHONE: this.phone },
        method: "POST",
        ignoreErrors: true
      };
      self.newOwner.USER = null;
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          let users_data = Object.values(data);
          if (users_data.length) {
            let user_data = users_data.shift();
            if (user_data.FIO) {
              self.newOwner.FIO = user_data.FIO;
            }
            if (user_data.ID) {
              self.newOwner.USER = user_data.ID;
            }
            if (user_data.ADDRESS) {
              self.newOwner.ADDRESS = user_data.ADDRESS;
            }
            if (user_data.PASSPORT_NUMBER) {
              self.newOwner.PASSPORT_NUMBER = user_data.PASSPORT_NUMBER;
            }
          }
        }
      });
    }
  },
  created() {
    this.getAgreementsType();
    this.getUsers();
  }
};
</script>
<style>
.form-row-wide {
  max-width: min-content;
}

.form-row-wide .form-field {
  width: 550px;
}
.form-field .vue-dadata__input {
  border-color: black;
}
.vue-dadata {
  width: 100%;
}
.suggestions-wrapper {
  position: relative;
  background-color: white;
}

.suggestions-suggestions {
  padding: 3px;
  background-color: white;
  cursor: pointer;
  border: 1px solid black;
}
</style>
